// getters
const cafeteriaDeliveries = state => state.cafeteriaDeliveries

export default {
  cafeteriaDeliveries
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/deliveries/getters.js